import "./OurServices.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurStrategicPillars from "./sections/OurStrategicPillars";
import TheRevbabaProcess from "./sections/TheRevbabaProcess";
import FooterInformation from "@/reusable_sections/Footer";
import Faq from "./sections/Faq";
import CaseStudies from "./sections/CaseStudies";
import RegionalRevenueGrid from "./sections/RegionalRevenueGrid";
export default function OurServicesPage() {
  return <div>
      <MainNavigation />
      <OurStrategicPillars />
      <TheRevbabaProcess />
      <CaseStudies />
      <Faq />
      <RegionalRevenueGrid />
      <FooterInformation />
    </div>;
}